import { ListItem, StyledComponentProps, Divider } from '@material-ui/core';
import * as React from 'react';
import { birthday } from '../../../../model/birthday';
import { BirthdayInfo } from './BirthdayInfo';
import moment from 'moment';

interface IContactItemProps extends StyledComponentProps {
    birthday: birthday;
    onBirthdayClick: (_id: string) => void;
    isSelected: boolean;
}

interface IContactItemState {
    open: boolean;
    openRoom: boolean;
}

export class BirthdayItem extends React.Component<IContactItemProps, IContactItemState> {
    state = { open: false, openRoom: false }

    renderStyle = (_birthday: birthday) => {
        var x: React.CSSProperties = {};
        if (_birthday) {
            var today = moment(new Date()).add(1, 'd').format('YYYYMMDD');
            // var iscurrentDate = moment(_birthday.birthDate).format('');
            // let amntOfTime = moment(_birthday.birthDate).fromNow();
            // let amntOfDays = moment(amntOfTime).format('days')
            // let day = moment(_birthday.birthDate).format('dddd')
            // let monAndYr = moment(_birthday.birthDate).format("MMMM Do YYYY")
            var xx = this.getFormattedDateDiff(today, _birthday.birthDate, undefined)
            // ['-22 years', '0 months', '0 weeks', '0 days']
            // console.log(today, _birthday.birthDate, xx)
            if (xx[1] === '0 months' && xx[2] === '0 weeks' && xx[3] === '0 days') {
                x = { backgroundColor: '#f46700', color: 'white', fontWeight: 'bold' };
            }
        }
        return x;
    }

    getFormattedDateDiff = (_date1, _date2, _intervals) => {
        var b = moment(_date1),
            a = moment(_date2),
            intervals = _intervals || ['years', 'months', 'weeks', 'days'],
            out = [];

        intervals.forEach(function (interval) {
            var diff = a.diff(b, interval);
            b.add(diff, interval);
            out.push(diff + ' ' + interval);
        });
        return out;
    }

    render() {
        const { birthday, classes } = this.props;
        return (
            <>
                {/* <Paper style={{ maxWidth: 'fit-content', ...this.renderStyle(birthday) }}>
                </Paper > */}

                <ListItem button
                    onClick={() => this.props.onBirthdayClick(this.props.birthday._id)}
                    style={this.renderStyle(birthday)}
                    className={this.props.isSelected ? classes.selectedBirthday : classes.birthday}
                >
                    <BirthdayInfo birthday={birthday} classes={classes} />
                </ListItem>
                < Divider />
            </>
        );
    }
}